document.addEventListener('DOMContentLoaded', function() {
            // Function to create skip links
            function createSkipLinks() {
                var skipLinks = document.querySelectorAll('.skip-link');

                skipLinks.forEach(function(link) {
                    link.addEventListener('click', function(event) {
                        event.preventDefault();
                        var targetId = this.getAttribute('href').substring(1);
                        var targetElement = document.getElementById(targetId);
                        if (targetElement) {
                            targetElement.setAttribute('tabindex', '-1');
                            targetElement.focus();
                        }
                    });
                });
            }

            // Create skip links when the DOM content is loaded
            createSkipLinks();
        });

